import { DataSourceType, DataSourceRelations } from "../model";

export const DATA_SOURCES_MAP: Record<DataSourceType, DataSourceRelations> = {
  az_file_share: {
    security_posture_group: ["AtRest"],
    security_postures: ["identities"],
    data_source: "az_file_share",
    desc:
      "Comprehensive file mapping and data classification for Azure File Share",
    icon: "AzureSimple",
    name: "Azure File Share",
  },
  msft_365_identities: {
    security_posture_group: ["CloudApp"],
    security_postures: ["identities"],
    data_source: "msft_365_identities",
    desc:
      "here goes the source descriptor it should be with a normal length not a full blown story",
    icon: "MsColor",
    name: "Microsoft 365 Identities Scanner",
  },

  az_ad_log: {
    security_posture_group: ["CloudApp"],
    security_postures: ["activities"],
    data_source: "az_ad_log",
    desc:
      "here goes the source descriptor it should be with a normal length not a full blown story",
    icon: "AzureSimple",
    name: "Azure Active Directory Activities Monitor",
  },
  az_resource_log: {
    security_posture_group: ["CloudApp"],
    security_postures: ["activities"],
    data_source: "az_resource_log",
    desc:
      "here goes the source descriptor it should be with a normal length not a full blown story",
    icon: "AzureSimple",
    name: "Azure Resource Activities Monitor",
  },
  aws_logs: {
    security_posture_group: ["CloudApp"],
    security_postures: ["activities"],
    data_source: "aws_logs",
    desc:
      "here goes the source descriptor it should be with a normal length not a full blown story",
    icon: "AWS",
    name: "AWS Activities Monitor",
  },
  cloud_mongo_db: {
    security_posture_group: ["AtRest"],
    security_postures: ["data_security"],
    data_source: "cloud_mongo_db",
    desc:
      "here goes the source descriptor it should be with a normal length not a full blown story",
    icon: "Mongo",
    name: "Cloud MongoDB Scanner",
  },
  github: {
    security_posture_group: ["CloudApp"],
    security_postures: ["activities"],
    data_source: "github",
    desc: "Comprehensive insights regarding data exports made from GitHub",
    icon: "Github",
    name: "Github",
  },
  google_workspace: {
    security_posture_group: ["InMotion"],
    security_postures: ["insider_threat"],
    data_source: "google_workspace",
    desc:
      "Comprehensive data classification, activities monitoring, and risk detection for Gmail and G-Suite",
    icon: "GoogleColor",
    name: "Google Workspace Activities Monitor",
  },
  motion_365: {
    security_posture_group: ["InMotion"],
    security_postures: ["insider_threat"],
    data_source: "motion_365",
    desc:
      "Comprehensive data classification, activities monitoring, and risk detection for Exchange Online, <b>SharePoint Online</b>, <b>OneDrive</b>, and <b>MS Teams.</b>",
    icon: "MsColor",
    name: "Microsoft 365 In-Motion",
  },
  msft_365: {
    security_posture_group: ["CloudApp"],
    security_postures: ["identities"],
    data_source: "msft_365",
    desc:
      "Comprehensive file mapping and data classification for <b>SharePoint Online</b>, <b>OneDrive</b>, and <b>MS Teams.</b>",
    icon: "MsColor",
    name: "Microsoft 365 At-Rest",
  },
  sp_site_permission: {
    security_posture_group: ["AtRest"],
    security_postures: ["information_access"],
    data_source: "sp_site_permission",
    desc: "Comprehensive site permissions mapping for SharePoint Online",
    icon: "MsColor",
    name: "Microsoft 365 SharePoint Permission",
  },
  onprem_db: {
    security_posture_group: ["CloudApp"],
    security_postures: ["data_security"],
    data_source: "onprem_db",
    desc:
      "here goes the source descriptor it should be with a normal length not a full blown story",
    icon: "OnPrem",
    name: "On-Premises Databases Scanner",
  },
  onprem_fs: {
    security_posture_group: ["AtRest"],
    security_postures: ["data_protection"],
    data_source: "onprem_fs",
    desc:
      "Comprehensive file mapping and data classification for On-Premise Network Drives.",
    icon: "OnPrem",
    name: "On-Premises File Server",
  },
  amazon_s3: {
    security_posture_group: ["AtRest"],
    security_postures: ["data_security"],
    data_source: "amazon_s3",
    desc:
      "Comprehensive storage objects mapping and data classification for Amazon S3 Storage Scanner.",
    icon: "AWS",
    name: "AWS S3",
  },
  mssql_db: {
    security_posture_group: ["AtRest"],
    security_postures: ["information_access"],
    data_source: "mssql_db",
    desc:
      "Data classification and risk detection for SQL Server databases, including automatic detection of tables containing Personal Identifiers.",
    icon: "MSSqlColor",
    name: "Microsoft SQL Server",
  },

  msft_dynamics: {
    security_posture_group: ["CloudApp"],
    security_postures: ["activities"],
    data_source: "msft_dynamics",
    desc:
      "Comprehensive insights regarding data exports made from Microsoft Dynamics 365",
    icon: "MS-DynamicsColor",
    name: "Microsoft Dynamics 365",
  },
  oracle_cloud_apps: {
    security_posture_group: ["CloudApp"],
    security_postures: ["activities"],
    data_source: "oracle_cloud_apps",
    desc:
      "here goes the source descriptor it should be with a normal length not a full blown story",
    icon: "Oracle",
    name: "Oracle Cloud Apps Activities Monitor",
  },

  salesforce: {
    security_posture_group: ["CloudApp"],
    security_postures: ["activities"],
    data_source: "salesforce",
    desc:
      "here goes the source descriptor it should be with a normal length not a full blown story",
    icon: "SalesForce",
    name: "Salesforce Activities Monitor",
  },

  az_storage: {
    security_posture_group: ["AtRest"],
    security_postures: ["data_security"],
    data_source: "az_storage",
    desc:
      "Comprehensive file mapping and data classification for Azure Storage",
    icon: "AzureSimple",
    name: "Azure Storage",
  },
  az_sql_db: {
    security_posture_group: ["AtRest"],
    security_postures: ["data_security"],
    data_source: "az_sql_db",
    desc:
      "Comprehensive file mapping and data classification for Azure SQL Databases.",
    icon: "AzureSimple",
    name: "Azure SQL Databases Scanner",
  },
  az_cosmos_db: {
    security_posture_group: ["AtRest"],
    security_postures: ["data_security"],
    data_source: "az_cosmos_db",
    desc:
      "Comprehensive file mapping and data classification for Azure Cosmos Databases.",
    icon: "AzureSimple",
    name: "Azure Cosmos Databases Scanner",
  },

  amazon_doc_db: {
    security_posture_group: ["AtRest"],
    security_postures: ["data_security"],
    data_source: "amazon_doc_db",
    desc:
      "here goes the source descriptor it should be with a normal length not a full blown story",
    icon: "AWS",
    name: "Amazon DocumentDB Activities Monitor",
  },
  hub_spot: {
    security_posture_group: ["CloudApp"],
    security_postures: ["activities"],
    data_source: "hub_spot",
    desc:
      "here goes the source descriptor it should be with a normal length not a full blown story",
    icon: "HubSpotColor",
    name: "HubSpot Activities Monitor",
  },
  gcp: {
    security_posture_group: ["AtRest"],
    security_postures: ["activities"],
    data_source: "gcp",
    desc:
      "Comprehensive file mapping and data classification for Google Cloud Platform.",
    icon: "GCPColor",
    name: "Google Cloud Platform",
  },
  dropbox_storage: {
    security_posture_group: ["AtRest"],
    security_postures: ["activities"],
    data_source: "dropbox_storage",
    desc: "Comprehensive file mapping and classification for Dropbox.",
    icon: "DropBoxColor",
    name: "Dropbox",
  },
  slack: {
    security_posture_group: ["InMotion"],
    security_postures: ["activities"],
    data_source: "slack",
    desc:
      "Comprehensive data classification, activities monitoring, and risk detection for Slack file sharing.",
    icon: "SlackColor",
    name: "Slack",
  },
  jira: {
    security_posture_group: ["CloudApp"],
    security_postures: ["activities"],
    data_source: "jira",
    desc:
      "Consolidated insights exposing exports made from connected Jira environments.",
    icon: "JiraColor",
    name: "Jira",
  },
  snowflake: {
    security_posture_group: ["AtRest"],
    security_postures: ["activities"],
    data_source: "snowflake",
    desc: "Data classification and risk detection for Snowflake environment",
    icon: "SnowflakeColor",
    name: "Snowflake",
  },
  confluence: {
    security_posture_group: ["CloudApp"],
    security_postures: ["activities"],
    data_source: "confluence",
    desc: "Comprehensive file mapping and classification for Confluence.",
    icon: "ConfluenceColor",
    name: "Confluence",
  },
  box: {
    security_posture_group: ["AtRest"],
    security_postures: ["activities"],
    data_source: "box",
    desc: "Comprehensive file mapping and classification for Box.",
    icon: "BoxColor",
    name: "",
  },
};
